import { render } from "./Navbar.vue?vue&type=template&id=2ca9169b&scoped=true&ts=true"
import script from "./Navbar.ts?vue&type=script&lang=ts&external"
export * from "./Navbar.ts?vue&type=script&lang=ts&external"

import "./Navbar.vue?vue&type=style&index=0&id=2ca9169b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca9169b"]])

export default __exports__